import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=768ca36c&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=768ca36c&prod&scoped=true&lang=css"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&id=768ca36c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768ca36c",
  null
  
)

export default component.exports